export default {
  methods: {
    goToExterior(exterior) {
      this.$router.push({
        name: 'order.overview.exterior',
        params: {
          order: this.$route.params.order,
          ...(exterior && exterior.parent ? { exteriorId: exterior.exterior_id } : {}),
        },
      });
    },
  },
};
